import { shuffleToDifferentOrder } from '@/shared/quiz/answerHidingShuffle';
import { seededShuffle } from '@/shared/utils/shuffle';

// 플레이 화면(orderDisplayOrder, 3)과 다르다. 플레이는 매번 다시 섞여 "2개면 항상 반대"를 학습할 수
// 있지만, 상세는 퀴즈마다 고정된 한 화면이라 2개도 정답 순서 그대로 보이지 않게 바꾸는 편이 낫다.
const MIN_ITEMS_TO_HIDE_CORRECT_ORDER = 2;

/**
 * seed 가 같으면 항상 같은 결과를 내는 셔플. SSR 과 클라이언트가 같은 순서를 그려야 해서
 * `seededShuffle` 로 섞는다. 2개 이상인데 원래 순서 그대로면 한 칸 회전한다.
 */
export const deterministicShuffle = <T>(
  items: readonly T[],
  getKey: (item: T) => string,
  seed: string,
): T[] =>
  shuffleToDifferentOrder(items, {
    minItems: MIN_ITEMS_TO_HIDE_CORRECT_ORDER,
    // 시드 셔플은 몇 번을 해도 같은 결과라, 한 번 보고 원래 순서면 바로 회전한다.
    maxAttempts: 1,
    shuffle: list => seededShuffle(list, getKey, seed),
  });
